import { axios } from "utils";

import { ADMIN_COURSE_URL as endpoint } from "consts";

export const addCourse = async (data) => axios.post(`${endpoint}`, { data });

export const deleteModule = async (data) => axios.delete(`${endpoint}/chapters/${data.chapterId}/modules/${data.moduleId}`, { data });

export const getAdminCourses = async (data) => axios.get(`${endpoint}`, { data });

export const addChapterToCourse = async (data) => axios.post(`${endpoint}/${data.courseId}/chapters`, { data });

export const getChaptersByCourse = async (data) => axios.get(`${endpoint}/${data.courseId}/chapters`, { data });

export const addModuleToChapter = async (data) =>
  axios.post(`${endpoint}/${data.courseId}/chapters/${data.chapterId}/modules`, {
    data,
  });

export const getModuleDetails = async (data) => axios.get(`${endpoint}/modules/${data.moduleId}`, { data });

export const deleteChapter = async (data) =>
  axios.delete(`${endpoint}/${data.courseId}/chapters/${data.chapterId}`, {
    data,
  });

export const reorderChapterModules = async (data) => axios.put(`${endpoint}/chapters/${data.chapterId}/modules`, { data });

export const updateCourseModule = async (data) =>
  axios.put(`${endpoint}/chapters/${data.chapterId}/modules/${data.moduleId}`, {
    data,
  });

export const getAdminCourse = async (data) => axios.get(`${endpoint}/${data.courseId}`, { data });

export const updateCourse = async (data) => axios.put(`${endpoint}/${data.courseId}`, { data });

export const updateChapter = async (data) => axios.put(`${endpoint}/chapters/${data.chapterId}`, { data });
